import type {CustomerLogo} from '@/ui/logos-carousel';

export const LOGO_BASE = '/static/images/industry-healthcare/customer-logos';

/** `file` matches basename in customer-logos/ (without .png). */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  {file: 'altius-logo_2x', label: 'Altius', width: 170, height: 80},
  {file: 'atec-logo_2x', label: 'ATEC', width: 140, height: 80},
  {file: 'brilliant-logo_2x', label: 'Brilliant', width: 100, height: 96},
  {file: 'doctorcare-logo_2x', label: 'Doctor Care', width: 180, height: 80},
  {file: 'h2health-logo_2x', label: 'H2 Health', width: 167, height: 96},
  {file: 'imdad-logo_2x', label: 'Imdad', width: 200, height: 80},
  {file: 'kooth-logo_2x', label: 'Kooth', width: 170, height: 80},
  {file: 'miracleear-logo_2x', label: 'Miracle-Ear', width: 220, height: 80},
  {file: 'navion-logo_2x', label: 'Navion', width: 200, height: 80},
  {file: 'parstherapy-logo_2x', label: 'PARS Therapy', width: 200, height: 65},
  {file: 'pharmacy2U-logo_2x', label: 'Pharmacy2U', width: 180, height: 80},
  {file: 'phoenix-logo_2x', label: 'Phoenix', width: 171, height: 80},
  {file: 'professional-logo_2x', label: 'Professional', width: 200, height: 96},
  {file: 'qualderm-logo_2x', label: 'Qualderm', width: 200, height: 80},
  {file: 'sunnyside-logo_2x', label: 'Sunnyside', width: 200, height: 80},
  {file: 'unilabs-logo_2x', label: 'Unilabs', width: 170, height: 85},
  {file: 'vitabiotics-logo_2x', label: 'Vitabiotics', width: 180, height: 80}
];
